/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { saveServiceAC } from '../../action-creators';
import { setInitialValues } from './utils/form-utils';
import { Field, Formik } from 'formik';
import { InputField } from './fields';
import { ActionsSection } from './buttons/actions-section';
import { Form } from 'semantic-ui-react';

const FIELDS = ['name', 'averageServiceTimeInMins'];

function ServiceForm(props: any) {
  const { dispatch, onClose } = props;
  const boundHandleSubmit = (values: any, formikActions: any) =>
    dispatch(
      saveServiceAC({ data: values, formikActions, closeDialog: onClose })
    );
  return (
    <Formik
      initialValues={setInitialValues(FIELDS, props)}
      onSubmit={boundHandleSubmit}
    >
      {({ values, handleSubmit, isSubmitting }: any) => (
        <Form onSubmit={handleSubmit}>
          <Field name="name" label="Name" component={InputField} />
          <Field
            name="averageServiceTimeInMins"
            label="Avg Service Time (mins)"
            component={InputField}
          />
          <ActionsSection
            isNew={!values.id}
            disabled={isSubmitting}
            onCancel={props.onClose}
          />
        </Form>
      )}
    </Formik>
  );
}

const ConnectedComponent = connect((state: any) => ({
  app: state.app,
  serviceProviders: state.serviceProviders,
  queues: state.queues,
  controlBoxes: state.controlBoxes
}))(ServiceForm);

export default ConnectedComponent;
